import { useEffect, useState } from 'react';

import { useReactNativeProps } from '@eika-infrastruktur/mobilbank-lib';

export const useEffectOnAppleWallet = (effect: () => void) => {
    const nativeProps = useReactNativeProps();
    const [notInitial, setNotInitial] = useState(false);

    useEffect(() => {
        if (notInitial) {
            effect();
        } else {
            setNotInitial(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nativeProps.appleWallet]);
};
